// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RoleGroupDescription: MarkdocTagRegistration = {
  tag: 'role-group-description',
  component: 'RoleGroupDescription',
  attributes: {
    groupName: {
      type: String,
      required: true,
      description: 'The name of the group of roles to display.',
      matches: [
        'admin',
        'connect',
        'corporateCard',
        'developer',
        'issuing',
        'opal',
        'payment',
        'support',
        'tax',
        'viewOnly',
      ],
    },
  },
};
